import React, { useState, useEffect, useContext, Fragment } from 'react';
import styled from 'styled-components';
import { path } from 'ramda';
import moment from 'moment';
import storage from 'local-storage-fallback';
import { RiCloseCircleLine } from "react-icons/ri";
import { IoCloseSharp } from "react-icons/io5";
import { useParams } from "react-router-dom";
import CircularProgress from '@material-ui/core/CircularProgress';
import Rating from '@mui/material/Rating';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { breakpoints } from '../../_helpers/breakpoints';
import { } from '../../_elements';

import MultipleChoice from './MultipleChoice';
import MultipleChoiceWithImage from './MultipleChoiceWithImage';
import { getAnswedData,
         answerSuccess } from '../../_helpers/commons';

import { ContentContext } from '../../_context';

import icon_evaluation_win from '../../_assets/images/icon_evaluation_win.svg';
import icon_evaluation_lose from '../../_assets/images/icon_evaluation_lose.svg';

import { GrLike, GrDislike } from "react-icons/gr";
import { BiLike, BiDislike } from "react-icons/bi";


import { STATUS_COURSE_BLOCKED,
         STATUS_COURSE_UNLOCKED,
         STATUS_COURSE_VIEWED,
         STATUS_COURSE_COMPLETED,
         STATUS_COURSE_REPROVED,
         STATUS_COURSE_PENDING_CONNECTION,
         STATUS_COURSE_IN_PROGRESS,
         STATUS_MODULE_BLOCKED,
         STATUS_MODULE_UNLOCKED,
         STATUS_MODULE_VIEWED,
         STATUS_MODULE_COMPLETED,
         STATUS_MODULE_REPROVED,
         STATUS_MODULE_PENDING_CONNECTION,
         STATUS_MODULE_IN_PROGRESS } from '~/_helpers/commons';

const DialogStyled = styled(Dialog)`
  p{
    margin: 0;
    padding: 0;
  }
  .MuiDialogContent-root{
    text-align: center;
  }
  .MuiPaper-rounded{
    border-radius: 15px;
  }
  .MuiDialogTitle-root{
    text-align: center;
  }
  .bt_continue,
  .bt_go_out{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 0 15px;
    background-color: #FFC600;
    border: 1px solid #FFC600;
    color: #000000;
    font-size: 17px;
    line-height: 17px;
    font-weight: 600;
    border-radius: 8px;
    margin-top: 65px;
    cursor: pointer;
    &.disabled{
      background-color: #E1E1E1;
      border: 1px solid #E1E1E1;
      color: #999999;
      cursor: default;
    }
    :hover{
      background-color: #FFFFFF;
      border: 1px solid #FFC600;
      color: #FFC600;
    }
  }
  .bt_go_out{
    background-color: #FFFFFF;
    border: 1px solid #D8010F;
    color: #D8010F;
    &:hover{
      background-color: #D8010F;
      color: #FFFFFF;
      border: 1px solid #D8010F;
    }
  }
`

const EvaluationStyled = styled.div`
  /* top: 0;
  left: 0;
  position: fixed; */
  display: flex;
  flex-direction: column;
  //align-items: center;
  //width: 100%;
  //height: 100%;
  //justify-content: flex-start;
  z-index: 10;
  padding-top: 0;
  //background-color: rgba(0, 0, 0, 0.75);
  position: relative;
  margin-bottom: 30px;
  width: 100%;

  .loader_block{
    svg{
      
        color: #faaf00;
      }
  }

  &.limit_attempts{
    .evaluation_inner{
      min-height: 200px;
    }
    
  }
  .limit_attempts_message{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin-top: 30px;
    .title{
      font-size: 20px;
      line-height: 25px;
      font-weight: 600;
    }
    .description{
      font-size: 16px;
      line-height: 20px;
      font-weight: 400;
      margin-top: 10px;
    }
  }
  .evaluation_inner{
    position: relative;
    width: 100%;
    min-height: ${props => props.isLoading ? "" : "360px"};
    border-radius: 0;
    background-color: ${props => props.win == null ? '#FFFFFF' : props.win.back };
    box-sizing: border-box;
    padding: 8vw 8vw 8vw 8vw;
    z-index: 12;
    
    .box_result_waiting{
      width: 100%;
      height: 150px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .box_result{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .media{
        margin-top: 15px;
        margin-bottom: 15px;
        &.imgWin{
          width: 290px;
        }
        &.imgLose{
          width: 280px;
          margin-top: 20px;
          margin-bottom: 20px;
        }
        img{
          float: left;
          width: 100%;
        }
      }
      .title{
        font-size: 30px;
        line-height: 30px;
        font-weight: 600;
        text-align: center;
        color: #FFFFFF;
      }
      .description{
        font-size: 20px;
        line-height: 25px;
        font-weight: 400;
        text-align: center;
        margin-top: 10px;
        color: #FFFFFF;
      }
      .points{
        font-size: 25px;
        line-height: 25px;
        font-weight: 600;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 15px;
        color: #FFC600;
      }
      
      .likes{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 15px;
        >.loader{
          svg{
            color: #faaf00;
          }
        }
        .title{
          font-size: 18px;
          line-height: 18px;
          font-weight: 500;
          color: #FFFFFF;//#FFC600;
        }
        .like_actions{
          display: flex;
          flex-direction: row;
          font-size: 35px;
          line-height: 35px;
          margin-top: 10px;
          color: #FFFFFF;
          .like{
            cursor: pointer;
            margin-right: 15px;
            &:hover{
              color: #FFC600;
            }
            &.selected{
              cursor: default;
              color: #FFC600;
            }
            &.blocked{
              cursor: default;
              color: #FFFFFF;
            }
          }
          .dislike{
            cursor: pointer;
            &:hover{
              color: #FFC600;
            }
            &.selected{
              cursor: default;
              color: #FFC600;
            }
            &.blocked{
              cursor: default;
              color: #FFFFFF;
            }
          }
        }
      }
      .rating{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        .title{
          font-size: 18px;
          line-height: 18px;
          font-weight: 500;
          color: #FFFFFF;
          margin-bottom: 10px;
        }
        label{
          margin-bottom: 0;
        }
        .MuiRating-root{
          .MuiRating-icon{
            color: #FFFFFF;
            &.MuiRating-iconHover,
            &.MuiRating-iconFocus,
            &.MuiRating-iconFilled{
              color: #FFC600;
            }
            .MuiSvgIcon-root{

            }
            :hover{
              .MuiSvgIcon-root{

              }
            }
          }
        }
        >.loader{
          flex-direction: row;
          display: flex;
          align-items: center;
          color: #556377;
          margin-left: 10px;
          svg{
            color: #faaf00;
          }
        }
      }
    }
    .evaluation_title{
      font-size: 15px;
      line-height: 15px;
      text-transform: uppercase;
      margin-bottom: 15px;
      text-align: center;
      color: ${props => props.win == null ? '#556377' : '#FFFFFF'};//#556377;
    }
    .loading{
      display: flex;
      flex-direction: row;
      justify-content: center;
      width: 100%;
      svg{
        color: #FFC600;
      }
    }
  }

  .evaluation_question_tabs{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    .question_tab{
      height: 2px;
      width: ${props => props.questions_total ? `calc(100% / ${props.questions_total} - 10px)` : "0"};
      background-color: #BFBFBF;
      &.active{
        background-color: #FFC600;
      }
      &.correct{
        background-color: green;
      }
      &.incorrect{
        background-color: red;
      }
    }
  }

  .evaluation_question_rest{
    text-align: center;
    margin-top: 20px;
  }

  .evaluation_question{
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
    text-align: center;
    margin-top: 20px;
    p{
      white-space: pre-line;
    }
  }



  .bt_next{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    padding: 0 15px;
    background-color: #FFC600;
    border: 1px solid #FFC600;
    color: #000000;
    font-size: 17px;
    line-height: 17px;
    font-weight: 600;
    border-radius: 8px;
    margin-top: 65px;
    cursor: pointer;
    :hover{
      background-color: ${props => props.answer_selected ? '#FFFFFF' : '#E1E1E1'};
    }
    &.disabled{
      background-color: #E1E1E1;
      border: 1px solid #E1E1E1;
      color: #999999;
      cursor: default;
      :hover{
        background-color: #E1E1E1;
        border: 1px solid #E1E1E1;
        color: #999999;
      }
    }
    
  }
  .bt_close{
    position: absolute;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    right: 5px;
    top: 5px;
    width: 40px;
    height: 40px;
    border-radius: 15px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 0;
    border: 1px solid #FFC600;
    background-color: #FFC600;
    color: #000000;
    font-size: 26px;
    cursor: pointer;
    :hover{
      background-color: #FFFFFF;
      color: #FFC600;
    }
  }
  @media ${breakpoints.xs} {
    
    .evaluation_inner{
      width: 100%;
      padding: 20px 40px 20px 40px;
      
    }
  }
  @media ${breakpoints.sm} {
    width: auto;
    padding-top: 30px;
    .evaluation_inner{
      width: 720px;
      border-radius: 15px;
    }
  }
  @media ${breakpoints.md} {
    .evaluation_inner{
      width: 800px;
      padding: 40px 80px 40px 80px;
    }
  }
  @media ${breakpoints.lg} {

  }
`

const EvaluationContainer = (props) => {

  let { id_course, id_module } = useParams();

  const {_id,
         scope,
         title,
         handleClose,
         evaluationData,
         setEvaluationData,
         parentData,
         evaluation,
         setEvaluation,
         handleRefreshData,
         allowPartialSubmission,
         setAllowPartialSubmission,
         attemptsCount, 
         setAttemptsCount,
         maxRetryAttempts,
         setMaxRetryAttempts,
         partialAnmswers,
         setPartialAnswers,
         failedQuestions,
         setFailedQuestions,
         isAttemptingEvaluation,
         setIsAttemptingEvaluation,
         match } = props

  const { campus,
          setCampus,
          evaluationActive,
          setEvaluationActive,
          save_grade_like,
          take_user_evaluation,
          save_assesment,
          save_assessment_progress } = useContext(ContentContext);

  const [ countOf, setCountOf ] = useState();
  const [ questionTotal, setQuestionTotal ] = useState();
  const [ order, setOrder ] = useState(0);
  const [ orderToShow, setOrderToShow ] = useState(1);
  const [ answersSelected, setAnswersSelected ] = useState([]);
  const [ answerEvaluation, setAnswerEvaluation ] = useState([]);
  const [ answerEvaluationObj, setAnswerEvaluationObj ] = useState({});
  const [ starEvaluationObj, setStarEvaluationObj ] = useState({});
  const [ likeEvaluationObj, setLikeEvaluationObj ] = useState({});
  const [ textButtonContinue, setTextButtonContinue ] = useState("Siguiente");
  const [ blockNext, setBlockNext ] = useState(false);
  const [ points, setPoints ] = useState(0);
  //const [ evaluation, setEvaluation ] = useState(null);
  const [ isLoading, setIsLoading ] = useState(true);
  const [ win, setWin ] = useState(null);
  const [ onResult, setOnResult ] = useState(null);
  const [ onPlay, setOnPlay ] = useState(null);
  const [ evaluationRating, setEvaluationRating ] = useState(0);
  const [ evaluationLike, setEvaluationLike ] = useState(null);
  const [ answerCorrect, setAnswerCorrect ] = useState([]);
  const [ answerIncorrect, setAnswerIncorrect ] = useState([]);
  const [ ladingRating, setLadingRating ] = useState(false);
  const [ ladingLike, setLadingLike ] = useState(false);
  
  const [ isRated, setIsRated ] = useState(false);
  const [ isLiked, setIsLiked ] = useState(false);

  const [ temporaryPartials, setTemporaryPartials ] = useState([]);
  const [ showExitModal, setShowExitModal ] = useState(false);
  const [ isNewAttempt, setIsNewAttempt ] = useState(false);
  const [ isComplete, setIsComplete ] = useState(false);
  const [ evaluationStepToShow, setEvaluationStepToShow ] = useState(null);

  useEffect(() => {

    setCountOf(1);
    setQuestionTotal(4);
    //console.log("⚽️⚽️⚽️", evaluation, evaluation.partial_anmswers ? evaluation.partial_anmswers.length+1 : 0);
    if(evaluation.allow_partial_submission){
      setOrderToShow(evaluation.partial_anmswers.length + 1);
      setTemporaryPartials(evaluation?.partial_anmswers ? evaluation.partial_anmswers : []);
    }else{
      setOrderToShow(1);
    }
    //setOrderToShow(evaluation.partial_anmswers ? evaluation.partial_anmswers.length + 1 : 1);

    return () => {}
  }, [])

  useEffect(() => {

    setIsLoading(true);
    //getEvaluation();

    return () => {}
  }, [])

  const getEvaluation = () => {

    let response;
    if(evaluationData.type == "module"){
      response = take_user_evaluation(evaluationData.id, "");
      response.then((res) => {
        setIsLoading(false);
        setOnPlay(true);
        setEvaluation(path(['data', 'single'], res));
      })
    }
    if(evaluationData.type == "course"){
      response = take_user_evaluation("", evaluationData.id);
      response.then((res) => {
        setIsLoading(false);
        setOnPlay(true);
        setEvaluation(path(['data', 'single'], res));
      })
    }

  }

  const getEvaluationStatus = () => {

    let response;
    if(evaluationData.type == "module"){
      response = take_user_evaluation(evaluationData.id, "");
      response.then((res) => {
        setOnPlay(false);
        setOnResult(true);
        setEvaluation(path(['data', 'single'], res));
      })
    }
    if(evaluationData.type == "course"){
      response = take_user_evaluation("", evaluationData.id);
      response.then((res) => {
        setOnPlay(false);
        setOnResult(true);
        setEvaluation(path(['data', 'single'], res));
      })
    }

  }

  useEffect(() => {

    if(evaluation){
      setIsLoading(false);
      if(!onResult){
        setOnPlay(true);
      }
    }

    return () => {}
  }, [evaluation])



  useEffect(() => {
    //console.log("---> evaluation", evaluation, parseInt(evaluation.count_questions, 10))
    //console.log("---> evaluation", evaluation)
    if(evaluation){
      setQuestionTotal(!evaluation?.failed_questions?.length ? parseInt(evaluation.count_questions, 10)/*evaluation.questions.length*/ : evaluation.failed_questions.length);
    }

    return () => {}
  }, [evaluation])

  useEffect(() => {

    return () => {
      setEvaluationData(null);
    }
  }, [])


  const handleNextQuestion = (index) => {
    //console.log("answersSelected", evaluation.questions[order]._id)

    
    //return null;
    setBlockNext(true);

    if(answersSelected){
      let obj_response_question = {};
      let secondary_actions_arr = [];
      answersSelected.map((a, i) => {
        //console.log(evaluation.questions[order].secondary_actions, a)
        const response = getAnswedData(evaluation.questions[order].secondary_actions, a);
        //console.log("response", response)
        if(response){
          secondary_actions_arr.push(response);
        }
        //
      })

      obj_response_question[evaluation.questions[order]._id] = secondary_actions_arr;
      

      setAnswerEvaluation([...answerEvaluation, obj_response_question]);

      let obj = {...answerEvaluationObj};
      obj[evaluation.questions[order]._id] = secondary_actions_arr;
      setAnswerEvaluationObj(obj)
      




      const pointsGained = answerSuccess(evaluation.questions[order].score,
                                         evaluation.questions[order]?.penalty_score ? evaluation.questions[order]?.penalty_score : 0,
                                         evaluation.questions[order].secondary_actions,
                                         answersSelected);

      if(pointsGained){
        obj_response_question["status"] = pointsGained.status;
        obj_response_question["score"] = pointsGained.score;

        if(pointsGained.status === 1){
          setAnswerCorrect([...answerCorrect, index]);
        }else{
          setAnswerIncorrect([...answerIncorrect, index]);
        }
      }

      if(allowPartialSubmission){
        //console.log("😎 allowPartialSubmission", allowPartialSubmission, answerEvaluation, obj_response_question);
        //console.log("🎁", [...answerEvaluation, obj_response_question]);
        //handleSendEvaluationProgress([...answerEvaluation, obj_response_question]);
        const { status, score, ...objWithoutStatusAndScore } = obj_response_question;
        handleSendEvaluationProgress(objWithoutStatusAndScore);
      }else{
        setBlockNext(false);
      }

      //console.log("🍓 allowPartialSubmission", allowPartialSubmission, obj_response_question);


    }else{

      return null;

    }
    
    const next = order + 1;
    //console.log("🍓 next", next, evaluation.questions.length-1, evaluation.questions, evaluation.questions[next])
    evaluation.questions.length-1 == next && setTextButtonContinue("Enviar");

    if(evaluation.questions.length-1 >= next){
      setOrder(next);
      setOrderToShow(prev => prev + 1);
      setAnswersSelected([]);
    }
    /*
    return null;

    if(answersSelected){

        let obj_response_question = {};
        let arr_option_id = [];
        let arr_option_text = [];
        let arr_option_media = [];

        answersSelected.map((a, i) => {
          const response = getAnswedData(evaluation.questions[order].secondary_actions, a);
          if(response){
            arr_option_id.push(response._id);
            arr_option_text.push(response.label);
            arr_option_media.push(response.media);
          }
        })

        obj_response_question["media"] = evaluation.questions[order].media;
        obj_response_question["optionSelectedId"] = arr_option_id;
        obj_response_question["questionText"] = evaluation.questions[order].title;
        obj_response_question["question_id"] = evaluation.questions[order]._id;

        if(evaluation.questions[order].input_type.title != 'single_choice_image' && evaluation.questions[order].input_type.title != 'multiple_choice_image'){
          obj_response_question["optionSelectedText"] = arr_option_text;
        }else{
          obj_response_question["optionSelectedText"] = [];
        }

        obj_response_question["status"] = '';
        obj_response_question["score"] = '';

        const pointsGained = answerSuccess(evaluation.questions[order].score,
                                           evaluation.questions[order]?.penalty_score ? evaluation.questions[order]?.penalty_score : 0,
                                           evaluation.questions[order].secondary_actions,
                                           answersSelected);

        if(pointsGained){

          obj_response_question["status"] = pointsGained.status;
          obj_response_question["score"] = pointsGained.score;//pointsGained.status === 1 ? evaluation.questions[order].score : 0;//evaluation.questions[order].score;//pointsGained.origina_score;

          if(pointsGained.status === 1){
            setAnswerCorrect([...answerCorrect, index]);
          }else{
            setAnswerIncorrect([...answerIncorrect, index]);
          }


          let newScore;
          if(pointsGained.action == "plus"){
            newScore = points + pointsGained.score;
          }
          if(pointsGained.action == "minus"){
            newScore = points - pointsGained.score;
          }
          setPoints(newScore);
        }

        setAnswerEvaluation([...answerEvaluation, obj_response_question]);

    }else{

      return null;

    }

    const next = order + 1;
    evaluation.questions.length-1 == next && setTextButtonContinue("Enviar");

    if(evaluation.questions.length-1 >= next){
      setOrder(next);
      setAnswersSelected([]);
    }
    */
  }
  
  
  const handleSendEvaluationProgress = (answerEvaluationObj) => {
    
    const payload = { evaluation_id: evaluation._id }

    if(scope == "module"){
      payload.content_id = _id;
    }

    if(scope == "course"){
      const splited_course_id = _id.split(":");
      payload.course_id = splited_course_id[1];
    }

    //console.log("🍖🍖🍖", payload, answerEvaluationObj);
    const response = save_assessment_progress(payload, answerEvaluationObj);
    response.then(res => {

      
      setBlockNext(false);

      //console.log("🎾 save_assessment_progress res", res);
      setIsComplete(res.data.single.is_complete);

      //setMaxRetryAttempts(res.data.single.max_retry_attempts);
      
      

      if(res.data.single.is_complete){

        setAttemptsCount(res.data.single.attempt_number/* + 1*/);
        setPoints(res.data.single.totalScore);
        setTemporaryPartials([]);
        
        setOnPlay(false);
        setOnResult(true);

        //setAttemptsCount(prev => prev + 1);
        //setIsNewAttempt(true);

        let approved;
        if(res.data.single.isApproved){
          approved = true;
          setWin({status: true,
                  scope: 'progresive',
                  back: 'rgba(0, 135, 85, 0.5)',
                  media: icon_evaluation_win,//evaluation.modal_success.media,
                  title: "¡Felicitaciones!",//evaluation.modal_success.title,
                  description: "Has aprobado la evaluación.",
                  remaining_text: null,
                  qualification_test: null});//evaluation.modal_success.description});
                  
        }else{
          approved = false;
          setWin({status: false,
                  scope: 'progresive',
                  back: 'rgba(218, 41, 28, 0.5)',
                  media: icon_evaluation_lose,//evaluation.modal_unsuccessfully.media,
                  title: "¡Vuelve a intentarlo!",//evaluation.modal_unsuccessfully.title,
                  description: "No obtuviste la suficiente calificación para aprobar la evaluación. Inicia nuevamente el curso para poder superarlo.",
                  remaining_text: "Intentos restantes: " + res.data.single.remaining_attempts + " de " + maxRetryAttempts,//evaluation.modal_unsuccessfully.description});
                  qualification_test: res.data.single.userScorePercentage + "%"});
        }


        if(scope === "course"){

          const course_splitted = _id.split(":");
          const campus_update = campus.categories.map(category => {
            if(course_splitted[0] === category._id){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  repo.evaluations[0].failed_questions = res.data.single.failed_questions;
                  repo.evaluations[0].attempts_count = res.data.single.attempt_number;// + 1;
                  repo.evaluations[0].remaining_attempts = res.data.single.remaining_attempts;
                  //repo.evaluations[0].partial_anmswers = res.data.single.partial_anmswers;
                  if(approved){
                    repo.certificate = res.data.single.certificate;
                    repo.status = STATUS_COURSE_COMPLETED;
                  }else{
                    if(res.data.single.remaining_attempts > 0){
                      repo.status = STATUS_COURSE_IN_PROGRESS;
                    }else{
                      repo.status = STATUS_COURSE_REPROVED;
                    }
                  }
                }
                return repo;
              })
            }
            return category;
          })
          //console.log("🫥 campus", campus)
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus_update;
          
          setCampus(campus_update_arr);
  
        }

      }else{

        setAttemptsCount(res.data.single.attempt_number/* + 1*/);
        setTemporaryPartials(res.data.single.partial_anmswers);
        /*
        if(scope === "course"){

          const course_splitted = _id.split(":");
          const campus_update = campus.categories.map(category => {
            if(course_splitted[0] === category._id){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  console.log("🤡🤡🤡🤡", repo.evaluations[0], repo.evaluations)
                  console.log("🎃🎃🎃🎃", res.data.single.partial_anmswers, res.data.single)
                  //repo.evaluations[0].failed_questions = res.data.single.failed_questions;
                  repo.evaluations[0].partial_anmswers = [...res.data.single.partial_anmswers];
                }
                return repo;
              })
            }
            return category;
          })
          
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus_update;
          console.log("🫥🫥🫥🫥 campus_update_arr", campus_update_arr)
          setCampus(campus_update_arr);
  
        }
        */

        if(!isNewAttempt){
          //setAttemptsCount(prev => prev + 1);
        }else{
          //setIsNewAttempt(true);
        }
        /*
        if(scope === "course"){

          const course_splitted = _id.split(":");
          const campus_update = campus.categories.map(category => {
            if(course_splitted[0] === category._id){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  repo.evaluations[0].partial_anmswers = res.data.single.partial_anmswers;
                }
                return repo;
              })
            }
            return category;
          })

          console.log("🫥 campus_update", campus_update)
          
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus_update;
          
          console.log("🫥🫥 campus_update_arr", campus_update_arr)

          setCampus(campus_update_arr);
  
        }
        */
      }

    })

  }

  const handleSendEvaluation = () => {

    const payload = { evaluation_id: evaluation._id,
                      //score: evaluation.score,
                      //approved: approved,
                      //id_content: scope == "module" ? id_module  : "",//id_module,
                      //id_curse: scope == "course" ? id_course  : "",//id_course,
                      //answers: answerEvaluationObj//JSON.stringify(answerEvaluationObj)//JSON.stringify(answerEvaluationObj)//answerEvaluation
                     }

    if(scope == "module"){
      const course_splitted = match.params.id_course.split(":");
      payload.course_id = course_splitted[1];
      payload.content_id = _id;
    }
    if(scope == "course"){
      const splited_course_id = _id.split(":");
      payload.course_id = splited_course_id[1];
    }

    console.log("🎁", payload);

    // despues del response
    setOnPlay(false);
    setOnResult(true);




    





    // console.log("payload", payload);
    //return null;

    const response = save_assesment(payload, answerEvaluationObj);
    response.then(res => {
      let approved;
      if(res.data.single.isApproved){
        approved = true;
        setWin({status: true,
                scope: 'direct',
                back: 'rgba(0, 135, 85, 0.5)',
                media: icon_evaluation_win,//evaluation.modal_success.media,
                title: "¡Felicitaciones!",//evaluation.modal_success.title,
                description: "Has aprobado la evaluación.",
                remaining_text: null,
                qualification_test: null});//evaluation.modal_success.description});
                
      }else{
        approved = false;
        setWin({status: false,
                scope: 'direct',
                back: 'rgba(218, 41, 28, 0.5)',
                media: icon_evaluation_lose,//evaluation.modal_unsuccessfully.media,
                title: "Evaluación no aprobada",//evaluation.modal_unsuccessfully.title,
                description: "La evaluación no fue resuelta correctamente. ¡Vuelve a intearlo!",
                remaining_text: null,
                qualification_test: null});//evaluation.modal_unsuccessfully.description});

      }

      setPoints(res.data.single.totalScore);

      if(scope === "course"){

          const course_splitted = _id.split(":");
          const campus_update = campus.categories.map(category => {
            if(course_splitted[0] === category._id){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  if(approved){
                    repo.certificate = res.data.single.certificate;
                    repo.status = STATUS_COURSE_COMPLETED;
                  }else{
                    repo.status = STATUS_COURSE_REPROVED;
                  }
                }
                return repo;
              })
            }
            return category;
          })
          //console.log("🫥 campus", campus)
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus_update;
          
          setCampus(campus_update_arr);
  
      }

      //console.log("🫥 match.params", match.params)

      if(scope === "module"){


          // const course_splitted = match.params.id_course.split(":");
          // console.log("☘️ course_splitted", course_splitted);
          // const courses = campus.categories.filter(category => category._id === course_splitted[0]);
          // console.log("☘️ courses", courses);
          // if(courses.length){
          //   const course_filtered = courses[0].repository.filter(course => course._id === course_splitted[1]);
          //   console.log("☘️ course_filtered", course_filtered);
          //   const module_filtered = course_filtered[0].moduls.filter(module => module._id === match.params.id_module);
          //   console.log("☘️ module_filtered", module_filtered);
          //   if(course_filtered.length){
          //     const module_filtered = course_filtered[0].moduls.filter(module => module._id === match.params.id_module);
          //     console.log("☘️", module_filtered)
          //     if(approved){
          //       module_filtered[0].status = STATUS_MODULE_COMPLETED;
          //     }else{
          //       module_filtered[0].status = STATUS_MODULE_REPROVED;
          //     }
          //   }
          // }

          const course_splitted = match.params.id_course.split(":");
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus.categories.map(category => {
            if(category._id === course_splitted[0]){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  const moduls_update = repo.moduls.map(module => {
                    if(module._id === match.params.id_module){
                      if(approved){
                        module.status = STATUS_MODULE_COMPLETED;
                      }else{
                        module.status = STATUS_MODULE_REPROVED;
                      }
                    }
                    return module;
                  });
                  repo.moduls = moduls_update;
                }
                return repo;
              });
              category.repository = repository_update;
            }
            return category;
          });
          
          setCampus(campus_update_arr);
      }







      











        /*
        let approved;
        if(res.data.single.approved){

          if(scope == "module"){
            handleRefreshData();
          }

          approved = true;
          setWin({status: true,
                  back: 'rgba(0, 85, 49, 0.5)',
                  media: evaluation.modal_success.media,
                  title: evaluation.modal_success.title,
                  description: evaluation.modal_success.description});
        }else{
          approved = false;
          setWin({status: false,
                  back: 'rgba(197, 0, 13, 0.5)',
                  media: evaluation.modal_unsuccessfully.media,
                  title: evaluation.modal_unsuccessfully.title,
                  description: evaluation.modal_unsuccessfully.description});
        }

        getEvaluationStatus();
        */
    })
  }
  
  useEffect(() => {
    
    //console.log("🌈🌈🌈 attemptsCount: ", attemptsCount);

    return () => {}
  }, [attemptsCount])

  useEffect(() => {
    
    //console.log("☘️☘️☘️ order: ", order);

    return () => {}
  }, [order])
  
  

  const handleEvaluationRating = (newValue) => {
    
    let payload = {};
    let objResponse = {};
    let obj_response_question = {};
    
    const survey_stars = evaluation.survey[0].questions.filter(question => question.type === "star");
    
    if(survey_stars.length){
      const option = survey_stars[0].secondary_actions.filter(option => option.label === newValue.toString());
      if(option.length){
        obj_response_question["optionSelectedId"] = [option[0]._id];
        obj_response_question["questionText"] = survey_stars[0].title;
        obj_response_question["_id"] = survey_stars[0]._id;
        obj_response_question["optionSelectedText"] = [option[0].label];
      }
      payload = { survey_id: survey_stars[0]._id, answers: [obj_response_question] }
      const splited_course_id = _id.split(":");
      payload.course_id = splited_course_id[1];

      setLadingRating(true);
      setIsRated(true);

      const grade_saved = save_grade_like(payload);
      grade_saved.then((res) => {
        setLadingRating(false);
      })

    }

    setEvaluationRating(newValue);
    return null;

  }

  const handleEvaluationLike = (newValue) => {
    
    let payload = {};
    let objResponse = {};
    let obj_response_question = {};
    
    const survey_like = evaluation.survey[0].questions.filter(question => question.type === "like");
    
    if(survey_like.length){
      const option = survey_like[0].secondary_actions.filter(option => option.label === newValue);
      if(option.length){
        obj_response_question["optionSelectedId"] = [option[0]._id];
        obj_response_question["questionText"] = survey_like[0].title;
        obj_response_question["_id"] = survey_like[0]._id;
        obj_response_question["optionSelectedText"] = [option[0].label];
      }
      payload = { survey_id: survey_like[0]._id, answers: [obj_response_question] }
      const splited_course_id = _id.split(":");
      payload.course_id = splited_course_id[1];

      setLadingLike(true);
      setIsLiked(true);

      const grade_saved = save_grade_like(payload);
      grade_saved.then((res) => {
        setLadingLike(false);
      })

    }

    setEvaluationLike(newValue);
    return null;
    
  }

  const handleCloseInner = () => {
    //console.log("----> handleCloseInner");
    if(evaluation.allow_partial_submission){

      //console.log("----> evaluation.allow_partial_submission", isComplete);
      

      if(isComplete){

        //console.log("----> scope", scope);

        if(scope === "course"){
          const course_splitted = _id.split(":");
          const campus_update = campus.categories.map(category => {
            if(course_splitted[0] === category._id){
              const repository_update = category.repository.map(repo => {
                if(repo._id === course_splitted[1]){
                  repo.evaluations[0].partial_anmswers = [];//temporaryPartials;
                }
                return repo;
              })
            }
            return category;
          })
          const campus_update_arr = {...campus};
          campus_update_arr.categories = campus_update;
          setCampus(campus_update_arr);
          storage.setItem('data_campus', JSON.stringify(campus_update_arr));
        }
        handleClose();

      }else{
        setShowExitModal(true);
      }
    }else{

      handleClose();

    }

    
  }
//console.log("data_campus: ", storage.getItem('data_campus'));
  const handleConfirmExit = () => {

    //console.log("----> handleConfirmExit", temporaryPartials);

    if(scope === "course"){
      const course_splitted = _id.split(":");
      const campus_update = campus.categories.map(category => {
        if(course_splitted[0] === category._id){
          const repository_update = category.repository.map(repo => {
            if(repo._id === course_splitted[1]){
              repo.evaluations[0].partial_anmswers = temporaryPartials;
            }
            return repo;
          })
        }
        return category;
      })
      const campus_update_arr = {...campus};
      campus_update_arr.categories = campus_update;
      setCampus(campus_update_arr);
      storage.setItem('data_campus', JSON.stringify(campus_update_arr));
    }
    setShowExitModal(false);
    handleClose();
  }

  const handleCancelExit = () => {
    setShowExitModal(false);
  }

  useEffect(() => {
    
    if(evaluation){
      if(answerEvaluation.length == evaluation.questions.length){
        //console.log("🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓 allowPartialSubmission: ", allowPartialSubmission);
        if(!allowPartialSubmission){
          handleSendEvaluation();
        }
      }
    }

    return () => {}
  }, [answerEvaluation])

  useEffect(() => {
    //console.log("🌈 isAttemptingEvaluation: ", isAttemptingEvaluation);
    return () => {}
  }, [isAttemptingEvaluation])

  useEffect(() => {
    //console.log("🍑🍑🍑🍑🍑🍑🍑🍑🍑🍑: ", evaluation.attempts_count +" >= "+ maxRetryAttempts);
    if(evaluation.allow_partial_submission){
      //if(evaluation.remaining_attempts === 0){
      if(evaluation.attempts_count === maxRetryAttempts){
        setEvaluationStepToShow('maxAttempts');
      }else{
        setEvaluationStepToShow('continueWithEvaluation');
      }
    }else{
      setEvaluationStepToShow('continueWithEvaluation');
    }
    

    return () => {}
  }, [])
  
  if(evaluationStepToShow === 'maxAttempts' ){
    return (
      <EvaluationStyled
        className={'limit_attempts'}
        questions_total={questionTotal}
        answer_selected={answersSelected.length ? true : false}
        win={win}
      > 
        <div className='evaluation_inner'>
            <Fragment>
              <div className='bt_close' onClick={() => { handleClose() }}>
                <IoCloseSharp />
              </div>
              <div className='evaluation_title'>
                {title}
              </div>
              <Fragment>
                <div className='limit_attempts_message'>
                  <div className='title'>
                    Límite de intentos alcanzado
                  </div>
                  <div className='description' style={{textAlign: 'center'}}>
                    Usaste todos tus intentos ({maxRetryAttempts} de {maxRetryAttempts}). No puedes reintentar esta evaluación.<br/><br/>
                    En 30 días se habilitará nuevamente la certificación. Te recomendamos repasar los cursos y contenidos de la sección Campus y Biblioteca.
                    <br/><br/><strong>¡Gracias!</strong>
                  </div>
                </div>
              </Fragment>
            </Fragment>
        </div>
      </EvaluationStyled>
    );
  }
  if(evaluationStepToShow === null){
    return (<>Calculin</>);
  }
  



/*
useEffect(() => {
 setOnResult(true);
 setWin({status: true,
                  scope: 'progresive',
                  back: 'rgba(218, 41, 28, 0.5)',
                  media: icon_evaluation_lose,//evaluation.modal_unsuccessfully.media,
                  title: "¡Vuelve a intentarlo!",//evaluation.modal_unsuccessfully.title,
                  description: "No obtuviste la suficiente calificación para aprobar la evaluación. Inicia nuevamente el curso para poder superarlo.",
                  remaining_text: "Intentos restantes: 1 de 3",//evaluation.modal_unsuccessfully.description});
                  qualification_test: "10%"});

}, [])
*/






  return (
    <EvaluationStyled
      className={''}
      questions_total={questionTotal}
      answer_selected={answersSelected.length ? true : false}
      win={win}
    >

      <div className='evaluation_inner'>
        {isLoading ?
          <div className='loading'>
          <CircularProgress />
        </div> : ""}

          {evaluation ?
          <Fragment>
            <div className='bt_close' onClick={handleCloseInner}>
              <IoCloseSharp />
            </div>
            <div className='evaluation_title'>
              {title}
            </div>
            {!evaluation.allow_partial_submission &&  
              <div className='evaluation_question_tabs'>
                {questionTotal && Array.from({ length: questionTotal }).map((_, index) => {
                  return(
                    <div key={index} className={`question_tab ${index == order ? 'active' : ''} ${answerCorrect.includes(index) ? ' correct' : ''} ${answerIncorrect.includes(index) ? ' incorrect' : ''}`}></div>
                  )
                })}
              </div>
            }
          </Fragment>
          : ""}

          {(!isLoading && onPlay && evaluation && !onResult) ?
          <Fragment>
            <div className='evaluation_question_rest'>
              <div className=''>Evaluación {/*order+1*/orderToShow}/{questionTotal}</div>
            </div>
            <div className='evaluation_question'>
              <p>{evaluation?.questions[order]?.title}</p>
            </div>
            {/* {console.log("****", evaluation.questions[order])} */}
            {evaluation?.questions[order]?.input_type[0]?.title === "single_choice" &&
              <MultipleChoice
                multiple={false}
                secondary_actions={evaluation?.questions[order]?.secondary_actions}
                order={order}
                answersSelected={answersSelected}
                setAnswersSelected={setAnswersSelected}
                answerEvaluation={answerEvaluation}
                setAnswerEvaluation={setAnswerEvaluation}
                question={evaluation?.questions[order]}
              />
            }

            {evaluation?.questions[order]?.input_type[0]?.title == "multiple_choice" &&
              <MultipleChoice
                multiple={true}
                secondary_actions={evaluation?.questions[order]?.secondary_actions}
                order={order}
                answersSelected={answersSelected}
                setAnswersSelected={setAnswersSelected}
                answerEvaluation={answerEvaluation}
                setAnswerEvaluation={setAnswerEvaluation}
                question={evaluation.questions[order]}
              />
            }

            {evaluation?.questions[order]?.input_type[0]?.title == "single_choice_image" &&
              <MultipleChoiceWithImage
                multiple={false}
                secondary_actions={evaluation?.questions[order]?.secondary_actions}
                order={order}
                answersSelected={answersSelected}
                setAnswersSelected={setAnswersSelected}
                answerEvaluation={answerEvaluation}
                setAnswerEvaluation={setAnswerEvaluation}
                question={evaluation?.questions[order]}
              />
            }

            {evaluation?.questions[order]?.input_type[0]?.title == "multiple_choice_image" &&
              <MultipleChoiceWithImage
                multiple={true}
                secondary_actions={evaluation?.questions[order]?.secondary_actions}
                order={order}
                answersSelected={answersSelected}
                setAnswersSelected={setAnswersSelected}
                answerEvaluation={answerEvaluation}
                setAnswerEvaluation={setAnswerEvaluation}
                question={evaluation?.questions[order]}
              />
            }
            <div className={`bt_next ${!answersSelected.length ? ' disabled' : ''} ${blockNext ? ' disabled' : ''}`} onClick={ () => { answersSelected.length && !blockNext && handleNextQuestion(order) } }>
              { blockNext ? <div className='loader_block'><CircularProgress size={24} /></div> : textButtonContinue }
            </div>
          </Fragment> : "" }


        {!isLoading && onResult ?
          win ?
          win.scope === "progresive" ?
          <div className='box_result'>
            <div className={`media ${win.status ? 'imgWin' : 'imgLose'}`}>
              <img src={win.media} />
            </div>
            <div className='title'>{ win.title }</div>
            <div className='description'>{ win.description }</div>
            <div className='points'>{ win.remaining_text }</div>
          </div>
          :
          <div className='box_result'>
            <div className={`media ${win.status ? 'imgWin' : 'imgLose'}`}>
              <img src={win.media} />
            </div>
            <div className='title'>{ win.title }</div>
            
            <div className='description'>{ win.status ? "Aprobaste la evaluación." : isAttemptingEvaluation ? win.description : "La evaluación no fue resuelta correctamente. ¡Volvé a intearlo!"/*win.description*/ }</div>

            {win.status ?
            <>
              <div className='points'>Puntaje: { points > 0 ? points : '0'}</div>
              {/* <div className='likes'>
                <div className='title'>¿Sentís que entendiste el contenido del curso?</div>
                <div className='like_actions'>
                  <div className={`like${evaluationLike === "Si" ? " selected" : evaluationLike !== null ? " blocked" : ""}`} onClick={() => !isLiked && handleEvaluationLike("Si")}>
                    <BiLike />
                  </div>
                  <div className={`dislike${evaluationLike === "No" ? " selected" : evaluationLike !== null ? " blocked" : ""}`} onClick={() => !isLiked && handleEvaluationLike("No")}>
                    <BiDislike />
                  </div>
                </div>
                {ladingLike ?
                <div className='loader'>
                  <CircularProgress size={20} />
                </div> : ""
                }
              </div>
              <div className='rating'>
                <div className='title'>¿Qué calificación le asignarías al curso?</div>
                <Rating
                  name="simple-controlled"
                  value={evaluationRating}
                  size="large"
                  readOnly={isRated}
                  onChange={(event, newValue) => {
                    handleEvaluationRating(newValue);
                  }}
                />

                {ladingRating ?
                <div className='loader'>
                  <CircularProgress size={20} />
                </div> : ""
                }
    
              </div>  */}
            </>
            : 
            "" }
          </div>
          :
          <div className='box_result_waiting'>
            <div className='loading'>
              <CircularProgress />
            </div>
          </div>
          : ""
        }
      </div>

      <DialogStyled
        open={showExitModal}
        onClose={handleCancelExit}
        aria-labelledby="exit-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle id="exit-dialog-title">¿Desea salir de la evaluación?</DialogTitle>
        <DialogContent>
          <div style={{ padding: '10px 0' }}>
            <p>Tus respuestas se guardarán por 7 días para poder continuar.<br/>Luego tendrás que comenzar de nuevo y perderás un intento.{/*Las respuestas se guardarán parcialmente y podrás continuar luego.*/}</p>
            <p>
              {/*Podes reintentar esta evaluación {maxRetryAttempts} veces.*/}<br/>
              {evaluation && evaluation.remaining_attempts !== undefined ? (
                <span style={{fontWeight: 'bold'}}> Estas en el intento {evaluation.attempts_count+1}{/*attemptsCount*/} de {maxRetryAttempts}</span>
              ) : (
                <span style={{fontWeight: 'bold'}}> Estas en el intento {evaluation.attempts_count+1}{/*attemptsCount*/} de {maxRetryAttempts}</span>
              )}
            </p>
          </div>
        </DialogContent>
        <DialogActions style={{ padding: '16px 24px' }}>
          <div className="bt_continue" onClick={handleCancelExit}>
            Continuar con esta evaluación
          </div>
          <div className="bt_go_out" onClick={handleConfirmExit}>
            Salir de todos modos
          </div>
        </DialogActions>
      </DialogStyled>


    </EvaluationStyled>
  )
}

export default EvaluationContainer;
